(function () {
  "use strict";

  var STATUS_LABELS = {
    matched: "In stock",
    partial: "Partial",
    out_of_stock: "Out of stock",
    not_found: "Not found",
    not_listed: "Not listed",
  };

  function init() {
    var root = document.getElementById("decklist-app");
    if (!root) return;

    var proxyUrl = root.getAttribute("data-proxy-url") || "/apps/decklist/match";
    var textEl = document.getElementById("decklist-text");
    var conditionEl = document.getElementById("decklist-condition");
    var excludeBasicsEl = document.getElementById("decklist-exclude-basics");
    var findBtn = document.getElementById("decklist-find");
    var clearBtn = document.getElementById("decklist-clear");
    var statusEl = document.getElementById("decklist-status");
    var resultsEl = document.getElementById("decklist-results");
    var summaryEl = document.getElementById("decklist-summary");
    var tableBody = document.getElementById("decklist-table-body");
    var selectAllEl = document.getElementById("decklist-select-all");
    var addCartBtn = document.getElementById("decklist-add-cart");
    var estimatedEl = document.getElementById("decklist-estimated");

    var currentLines = [];

    function setStatus(message, type) {
      statusEl.hidden = !message;
      statusEl.textContent = message || "";
      statusEl.className = "decklist__status" + (type ? " decklist__status--" + type : "");
    }

    function formatMoney(value) {
      var num = parseFloat(value);
      if (isNaN(num)) return "$0.00";
      return "$" + num.toFixed(2);
    }

    function computeSelectedTotal() {
      var total = 0;
      var rows = tableBody.querySelectorAll("tr[data-index]");
      rows.forEach(function (row) {
        var checkbox = row.querySelector('input[type="checkbox"]');
        var qtyInput = row.querySelector(".decklist__qty-input");
        var price = parseFloat(row.getAttribute("data-price") || "0");
        if (checkbox && checkbox.checked && qtyInput) {
          total += price * parseInt(qtyInput.value, 10);
        }
      });
      estimatedEl.textContent = "Selected subtotal: " + formatMoney(total);
    }

    function renderResults(data) {
      currentLines = data.lines || [];
      summaryEl.textContent =
        (data.summary.totalLines || 0) +
        " cards — " +
        (data.summary.matched || 0) +
        " in stock, " +
        (data.summary.partial || 0) +
        " partial, " +
        (data.summary.notFound || 0) +
        " not found, " +
        (data.summary.notListed || 0) +
        " not listed.";

      tableBody.innerHTML = "";
      currentLines.forEach(function (line, index) {
        var tr = document.createElement("tr");
        tr.setAttribute("data-index", String(index));
        tr.setAttribute("data-price", line.price || "0");
        if (!line.selectable) tr.classList.add("decklist__row--muted");

        var nameHtml = line.productUrl
          ? '<a class="decklist__card-link" href="' +
            line.productUrl +
            '">' +
            escapeHtml(line.matchedName || line.cardName) +
            "</a>"
          : escapeHtml(line.matchedName || line.cardName);

        var badgeClass = "decklist__status-badge decklist__status-badge--" + line.status;
        var statusText = STATUS_LABELS[line.status] || line.status;

        tr.innerHTML =
          '<td><input type="checkbox" data-index="' +
          index +
          '" ' +
          (line.selectable ? "checked" : "disabled") +
          "></td>" +
          "<td>" +
          nameHtml +
          (line.setHint ? '<br><small>' + escapeHtml(line.setHint) + "</small>" : "") +
          "</td>" +
          "<td>" +
          line.qtyRequested +
          "</td>" +
          "<td>" +
          line.qtyAvailable +
          "</td>" +
          '<td><input class="decklist__qty-input" type="number" min="0" max="' +
          Math.max(line.qtyAvailable, 0) +
          '" value="' +
          line.qtyToAdd +
          '" ' +
          (line.selectable ? "" : "disabled") +
          "></td>" +
          "<td>" +
          (line.price ? formatMoney(line.price) : "—") +
          "</td>" +
          '<td><span class="' +
          badgeClass +
          '">' +
          statusText +
          "</span></td>";

        tableBody.appendChild(tr);
      });

      resultsEl.hidden = false;
      clearBtn.hidden = false;
      estimatedEl.textContent = "Estimated (in-stock qty): " + formatMoney(data.summary.estimatedTotal);
      computeSelectedTotal();
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    findBtn.addEventListener("click", function () {
      var text = (textEl.value || "").trim();
      if (!text) {
        setStatus("Paste a decklist first.", "error");
        return;
      }

      findBtn.disabled = true;
      setStatus("Matching cards against our inventory…", "");

      fetch(proxyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          text: text,
          condition: conditionEl.value,
          excludeBasics: excludeBasicsEl.checked,
        }),
      })
        .then(function (res) {
          return res.text().then(function (raw) {
            var body;
            try {
              body = raw ? JSON.parse(raw) : {};
            } catch (e) {
              if (raw && /^\s*</.test(raw)) {
                throw new Error(
                  "Match API returned a web page instead of JSON. App Proxy is probably not configured — " +
                    "Shopify Admin → your app → App proxy → Proxy URL = https://YOUR-decklist-api-url/apps/decklist " +
                    "(see README-decklist.md). Request: " +
                    proxyUrl +
                    " → HTTP " +
                    res.status
                );
              }
              throw new Error("Match API returned invalid JSON (HTTP " + res.status + ").");
            }
            return { ok: res.ok, body: body };
          });
        })
        .then(function (_ref) {
          var ok = _ref.ok;
          var body = _ref.body;
          if (!ok || !body.ok) {
            throw new Error((body && body.error) || "Matching failed.");
          }
          renderResults(body);
          setStatus("Review your matches below, then add selected cards to cart.", "success");
        })
        .catch(function (err) {
          setStatus(err.message || "Something went wrong.", "error");
        })
        .finally(function () {
          findBtn.disabled = false;
        });
    });

    clearBtn.addEventListener("click", function () {
      currentLines = [];
      tableBody.innerHTML = "";
      resultsEl.hidden = true;
      clearBtn.hidden = true;
      setStatus("", "");
    });

    selectAllEl.addEventListener("change", function () {
      tableBody.querySelectorAll('input[type="checkbox"]:not(:disabled)').forEach(function (cb) {
        cb.checked = selectAllEl.checked;
      });
      computeSelectedTotal();
    });

    tableBody.addEventListener("change", function (event) {
      if (event.target.matches('input[type="checkbox"], .decklist__qty-input')) {
        computeSelectedTotal();
      }
    });

    addCartBtn.addEventListener("click", function () {
      var items = [];
      tableBody.querySelectorAll("tr[data-index]").forEach(function (row) {
        var checkbox = row.querySelector('input[type="checkbox"]');
        var qtyInput = row.querySelector(".decklist__qty-input");
        var index = parseInt(row.getAttribute("data-index"), 10);
        var line = currentLines[index];
        if (!checkbox || !checkbox.checked || !line || !line.shopifyVariantId) return;
        var qty = parseInt(qtyInput.value, 10);
        if (!qty || qty <= 0) return;
        items.push({ id: line.shopifyVariantId, quantity: qty });
      });

      if (!items.length) {
        setStatus("Select at least one in-stock card to add.", "error");
        return;
      }

      addCartBtn.disabled = true;
      setStatus("Adding " + items.length + " line(s) to cart…", "");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              throw new Error(body.description || body.message || "Cart add failed.");
            });
          }
          return res.json();
        })
        .then(function () {
          setStatus("Added to cart! Opening cart…", "success");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          if (typeof window.openCartDrawer === "function") {
            window.openCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function (err) {
          setStatus(err.message || "Could not add to cart.", "error");
        })
        .finally(function () {
          addCartBtn.disabled = false;
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
